import type { AllRouteEndpoints } from "../routeTypes";

export const engagementLandingPagesAppGroupIdLandingPageId =
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id";

// If applicable consider also updating engagementLandingPagesAppGroupIdUpdateArchivedStateCacheKeys
export const engagementLandingPagesAppGroupIdLandingPageIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id",
  "/engagement/landing_page_data",
  "/engagement/landing_pages_data",
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/preview",
  "/engagement/landing_pages/:app_group_id/limits",
  "/engagement/landing_pages/:app_group_id/size_limits",
];
